export const GET_LIST_POOL_START = 'GET_LIST_POOL_START'
export const GET_LIST_POOL_SUCCESS = 'GET_LIST_POOL_SUCCESS'
export const GET_LIST_POOL_FAILED = 'GET_LIST_POOL_FAILED'

export const CREATE_POOL_START = 'CREATE_POOL_START'
export const CREATE_POOL_SUCCESS = 'CREATE_POOL_SUCCESS'
export const CREATE_POOL_FAILED = 'CREATE_POOL_FAILED'

export const EDIT_POOL_START = 'EDIT_POOL_START'
export const EDIT_POOL_SUCCESS = 'EDIT_POOL_SUCCESS'
export const EDIT_POOL_FAILED = 'EDIT_POOL_FAILED'

export const CLOSE_POOL_START = 'CLOSE_POOL_START'
export const CLOSE_POOL_SUCCESS = 'CLOSE_POOL_SUCCESS'
export const CLOSE_POOL_FAILED = 'CLOSE_POOL_FAILED'

export const GET_DEPOSIT_POOLS_START = 'GET_DEPOSIT_POOLS_START'
export const GET_DEPOSIT_POOLS_SUCCESS = 'GET_DEPOSIT_POOLS_SUCCESS'
export const GET_DEPOSIT_POOLS_FAILED = 'GET_DEPOSIT_POOLS_FAILED'

export const GET_WITHDRAW_POOLS_START = 'GET_WITHDRAW_POOLS_START'
export const GET_WITHDRAW_POOLS_SUCCESS = 'GET_WITHDRAW_POOLS_SUCCESS'
export const GET_WITHDRAW_POOLS_FAILED = 'GET_WITHDRAW_POOLS_FAILED'

export const UPDATE_DEPOSIT_POOLS_START = 'UPDATE_DEPOSIT_POOLS_START'
export const UPDATE_DEPOSIT_POOLS_SUCCESS = 'UPDATE_DEPOSIT_POOLS_SUCCESS'
export const UPDATE_DEPOSIT_POOLS_FAILED = 'UPDATE_DEPOSIT_POOLS_FAILED'

export const UPDATE_WITHDRAW_POOLS_START = 'UPDATE_WITHDRAW_POOLS_START'
export const UPDATE_WITHDRAW_POOLS_SUCCESS = 'UPDATE_WITHDRAW_POOLS_SUCCESS'
export const UPDATE_WITHDRAW_POOLS_FAILED = 'UPDATE_WITHDRAW_POOLS_FAILED'

export const DELETE_API_GAME_MONSTER_NFT_START =
  'DELETE_API_GAME_MONSTER_NFT_START'
export const DELETE_API_GAME_MONSTER_NFT_SUCCESS =
  'DELETE_API_GAME_MONSTER_NFT_SUCCESS'
export const DELETE_API_GAME_MONSTER_NFT_FAILED =
  'DELETE_API_GAME_MONSTER_NFT_FAILED'

export const DELETE_API_MARKET_MONSTER_NFT_START =
  'DELETE_API_MARKET_MONSTER_NFT_START'
export const DELETE_API_MARKET_MONSTER_NFT_SUCCESS =
  'DELETE_API_MARKET_MONSTER_NFT_SUCCESS'
export const DELETE_API_MARKET_MONSTER_NFT_FAILED =
  'DELETE_API_MARKET_MONSTER_NFT_FAILED'

export const DEPOSIT_HASHCHIP_POOL_START = 'DEPOSIT_HASHCHIP_POOL_START'
export const DEPOSIT_HASHCHIP_POOL_SUCCESS = 'DEPOSIT_HASHCHIP_POOL_SUCCESS'
export const DEPOSIT_HASHCHIP_POOL_FAILED = 'DEPOSIT_HASHCHIP_POOL_FAILED'

export const WITHDRAW_HASH_CHIP_POOL_START = 'WITHDRAW_HASH_CHIP_POOL_START'
export const WITHDRAW_HASH_CHIP_POOL_SUCCESS = 'WITHDRAW_HASH_CHIP_POOL_SUCCESS'
export const WITHDRAW_HASH_CHIP_POOL_FAILED = 'WITHDRAW_HASH_CHIP_POOL_FAILED'

export const GET_STATISTIC_HASH_CHIP_POOL_START = 'GET_STATISTIC_HASH_CHIP_POOL_START'
export const GET_STATISTIC_HASH_CHIP_POOL_SUCCESS = 'GET_STATISTIC_HASH_CHIP_POOL_SUCCESS'
export const GET_STATISTIC_HASH_CHIP_POOL_FAILED = 'GET_STATISTIC_HASH_CHIP_POOL_FAILED'

export const GET_HISTORIES_HASH_CHIP_POOL_START = 'GET_HISTORIES_HASH_CHIP_POOL_START'
export const GET_HISTORIES_HASH_CHIP_POOL_SUCCESS = 'GET_HISTORIES_HASH_CHIP_POOL_SUCCESS'
export const GET_HISTORIES_HASH_CHIP_POOL_FAILED = 'GET_HISTORIES_HASH_CHIP_POOL_FAILED'

export const GET_PROCESS_HASH_CHIP_POOL_START = 'GET_PROCESS_HASH_CHIP_POOL_START'
export const GET_PROCESS_HASH_CHIP_POOL_SUCCESS = 'GET_PROCESS_HASH_CHIP_POOL_SUCCESS'
export const GET_PROCESS_HASH_CHIP_POOL_FAILED = 'GET_PROCESS_HASH_CHIP_POOL_FAILED'

export const GET_RANKING_REWARDS_START = 'GET_RANKING_REWARDS_START'
export const GET_RANKING_REWARDS_SUCCESS = 'GET_RANKING_REWARDS_SUCCESS'
export const GET_RANKING_REWARDS_FAILED = 'GET_RANKING_REWARDS_FAILED'

export const GET_HISTORY_RANKING_REWARDS_START = 'GET_HISTORY_RANKING_REWARDS_START'
export const GET_HISTORY_RANKING_REWARDS_SUCCESS = 'GET_HISTORY_RANKING_REWARDS_SUCCESS'
export const GET_HISTORY_RANKING_REWARDS_FAILED = 'GET_HISTORY_RANKING_REWARDS_FAILED'

//-------------------------Pools------------------------//
/**
 * [1]
 * get deposit pools start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function getDepositPools(payload, onSuccess, onError) {
  return {
    type: GET_DEPOSIT_POOLS_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * get deposit pools success action
 * @param {*} payload
 * @returns {object}
 */
export function getDepositPoolsSuccess(payload) {
  return {
    type: GET_DEPOSIT_POOLS_SUCCESS,
    payload: payload,
  }
}

/**
 * get deposit pools failed action
 * @returns {object}
 */
export function getDepositPoolsFailed() {
  return {
    type: GET_DEPOSIT_POOLS_FAILED,
  }
}

/**
 * [2]
 * get withdraw pools start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function getWithdrawPools(payload, onSuccess, onError) {
  return {
    type: GET_WITHDRAW_POOLS_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * get withdraw pools success action
 * @param {*} payload
 * @returns {object}
 */
export function getWithdrawPoolsSuccess(payload) {
  return {
    type: GET_WITHDRAW_POOLS_SUCCESS,
    payload: payload,
  }
}

/**
 * get withdraw pools failed action
 * @returns {object}
 */
export function getWithdrawPoolsFailed() {
  return {
    type: GET_WITHDRAW_POOLS_FAILED,
  }
}

/**
 * [3]
 * update deposit pools start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function updateDepositPools(payload, onSuccess, onError) {
  return {
    type: UPDATE_DEPOSIT_POOLS_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * update deposit pools success action
 * @param {*} payload
 * @returns {object}
 */
export function updateDepositPoolsSuccess(payload) {
  return {
    type: UPDATE_DEPOSIT_POOLS_SUCCESS,
    payload: payload,
  }
}

/**
 * update deposit pools failed action
 * @returns {object}
 */
export function updateDepositPoolsFailed() {
  return {
    type: UPDATE_DEPOSIT_POOLS_FAILED,
  }
}

/**
 * [4]
 * update withdraw pools start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function updateWithdrawPools(payload, onSuccess, onError) {
  return {
    type: UPDATE_WITHDRAW_POOLS_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * update withdraw pools success action
 * @param {*} payload
 * @returns {object}
 */
export function updateWithdrawPoolsSuccess(payload) {
  return {
    type: UPDATE_WITHDRAW_POOLS_SUCCESS,
    payload: payload,
  }
}

/**
 * update withdraw pools failed action
 * @returns {object}
 */
export function updateWithdrawPoolsFailed() {
  return {
    type: UPDATE_WITHDRAW_POOLS_FAILED,
  }
}

/**
 * [5]
 * get list pools start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function getListPools(payload, onSuccess, onError) {
  return {
    type: GET_LIST_POOL_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * get list pools success action
 * @param {*} payload
 * @returns {object}
 */
export function getListPoolsSuccess(payload) {
  return {
    type: GET_LIST_POOL_SUCCESS,
    payload: payload,
  }
}

/**
 * get list pools failed action
 * @returns {object}
 */
export function getListPoolsFailed() {
  return {
    type: GET_LIST_POOL_FAILED,
  }
}

/**
 * [6]
 * Create pools start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function createPool(payload, onSuccess, onError) {
  return {
    type: CREATE_POOL_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * Create pools success action
 * @param {*} payload
 * @returns {object}
 */
export function createPoolSuccess(payload) {
  return {
    type: CREATE_POOL_SUCCESS,
    payload: payload,
  }
}

/**
 * Create pool failed action
 * @returns {object}
 */
export function createPoolFailed() {
  return {
    type: CREATE_POOL_FAILED,
  }
}

/**
 * [7]
 * Edit pools start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function editPool(payload, onSuccess, onError) {
  return {
    type: EDIT_POOL_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * Edit pools success action
 * @param {*} payload
 * @returns {object}
 */
export function editPoolSuccess(payload) {
  return {
    type: EDIT_POOL_SUCCESS,
    payload: payload,
  }
}

/**
 * Edit pool failed action
 * @returns {object}
 */
export function editPoolFailed() {
  return {
    type: EDIT_POOL_FAILED,
  }
}

/**
 * [8]
 * Close pools start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function closePool(payload, onSuccess, onError) {
  return {
    type: CLOSE_POOL_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * Close pools success action
 * @param {*} payload
 * @returns {object}
 */
export function closePoolSuccess(payload) {
  return {
    type: CLOSE_POOL_SUCCESS,
    payload: payload,
  }
}

/**
 * Close pool failed action
 * @returns {object}
 */
export function closePoolFailed() {
  return {
    type: CLOSE_POOL_FAILED,
  }
}

/**
 * [9]
 * delete nft start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function deleteNFTgame(payload, onSuccess, onError) {
  return {
    type: DELETE_API_GAME_MONSTER_NFT_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * delete nft success action
 * @param {*} payload
 * @returns {object}
 */
export function deleteNFTgameSuccess(payload) {
  return {
    type: DELETE_API_GAME_MONSTER_NFT_SUCCESS,
    payload: payload,
  }
}

/**
 * delete failed action
 * @returns {object}
 */
export function deleteNFTgameFailed() {
  return {
    type: DELETE_API_GAME_MONSTER_NFT_FAILED,
  }
}
/**
 * [10]
 * delete nft start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function deleteNFTmarket(payload, onSuccess, onError) {
  return {
    type: DELETE_API_MARKET_MONSTER_NFT_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * delete nft success action
 * @param {*} payload
 * @returns {object}
 */
export function deleteNFTmarketSuccess(payload) {
  return {
    type: DELETE_API_MARKET_MONSTER_NFT_SUCCESS,
    payload: payload,
  }
}

/**
 * delete failed action
 * @returns {object}
 */
export function deleteNFTmarketFailed() {
  return {
    type: DELETE_API_MARKET_MONSTER_NFT_FAILED,
  }
}

/**
 * [11]
 * Deposit Hashchip Pool start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function depositHashchipPool(payload, onSuccess, onError) {
  return {
    type: DEPOSIT_HASHCHIP_POOL_START,
    payload,
    onSuccess,
    onError
  }
}

/**
 * Deposit Hashchip Pool success action
 * @param {*} payload
 * @returns {object}
 */
export function depositHashchipPoolSuccess(payload) {
  return {
    type: DEPOSIT_HASHCHIP_POOL_SUCCESS,
    payload
  }
}

/**
 * Deposit Hashchip Pool failed action
 * @param {*} payload
 * @returns {object}
 */
export function depositHashchipPoolFailed() {
  return {
    type: DEPOSIT_HASHCHIP_POOL_FAILED
  }
}

/**
 * [12]
 * Withdraw Hashchip Pool start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function withdrawHashChipPool(payload, onSuccess, onError) {
  return {
    type: WITHDRAW_HASH_CHIP_POOL_START,
    payload,
    onSuccess,
    onError
  }
}

/**
 * Withdraw Hashchip Pool success action
 * @param {*} payload
 * @returns {object}
 */
export function  withdrawHashChipPoolSuccess(payload) {
  return {
    type: WITHDRAW_HASH_CHIP_POOL_SUCCESS,
    payload
  }
}

/**
 * Withdraw Hashchip Pool failed action
 * @param {*} payload
 * @returns {object}
 */
export function  withdrawHashChipPoolFailed() {
  return {
    type: WITHDRAW_HASH_CHIP_POOL_FAILED
  }
}

/**
 * [13]
 * Get Statistic Hash chip Pool start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function getStatisticHashChipPool(payload, onSuccess, onError) {
  return {
    type: GET_STATISTIC_HASH_CHIP_POOL_START,
    payload,
    onSuccess,
    onError
  }
}

/**
 * Get Statistic Hashchip Pool success action
 * @param {*} payload
 * @returns {object}
 */
export function  getStatisticHashChipPoolSuccess(payload) {
  return {
    type: GET_STATISTIC_HASH_CHIP_POOL_SUCCESS,
    payload
  }
}

/**
 * Get Statistic Hashchip Pool failed action
 * @param {*} payload
 * @returns {object}
 */
export function  getStatisticHashChipPoolFailed() {
  return {
    type: GET_STATISTIC_HASH_CHIP_POOL_FAILED
  }
}

/**
 * [14]
 * Get histories Hash chip redeemed start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function getHistoriesHashChipPool(payload, onSuccess, onError) {
  return {
    type: GET_HISTORIES_HASH_CHIP_POOL_START,
    payload,
    onSuccess,
    onError
  }
}

/**
 * Get histories Hashchip redeemed success action
 * @param {*} payload
 * @returns {object}
 */
export function  getHistoriesHashChipPoolSuccess(payload) {
  return {
    type: GET_HISTORIES_HASH_CHIP_POOL_SUCCESS,
    payload
  }
}

/**
 * Get histories Hashchip redeemed failed action
 * @param {*} payload
 * @returns {object}
 */
export function  getHistoriesHashChipPoolFailed() {
  return {
    type: GET_HISTORIES_HASH_CHIP_POOL_FAILED
  }
}

/**
 * [15]
 * Get process Hash chip redeemed start action
 * @param {any} payload
 * @param {function} onSuccess Callback function on success
 * @param {*} onError Callback function on error
 * @returns {object}
 */
export function getProcessHashChipPool(payload, onSuccess, onError) {
  return {
    type: GET_PROCESS_HASH_CHIP_POOL_START,
    payload,
    onSuccess,
    onError
  }
}

/**
 * Get process Hashchip redeemed success action
 * @param {*} payload
 * @returns {object}
 */
export function getProcessHashChipPoolSuccess(payload) {
  return {
    type: GET_PROCESS_HASH_CHIP_POOL_SUCCESS,
    payload
  }
}

/**
 * Get process Hashchip redeemed failed action
 * @param {*} payload
 * @returns {object}
 */
export function getProcessHashChipPoolFailed() {
  return {
    type: GET_PROCESS_HASH_CHIP_POOL_FAILED
  }
}

export function getRankingRewards(payload, onSuccess, onError) {
  return {
    type: GET_RANKING_REWARDS_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

export function getRankingRewardsSuccess(payload) {
  return {
    type: GET_RANKING_REWARDS_SUCCESS,
    payload: payload,
  }
}

export function getRankingRewardsFailed() {
  return {
    type: GET_RANKING_REWARDS_FAILED,
  }
}

export function getHistoryRankingRewards(payload, onSuccess, onError) {
  return {
    type: GET_HISTORY_RANKING_REWARDS_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

export function getHistoryRankingRewardsSuccess(payload) {
  return {
    type: GET_HISTORY_RANKING_REWARDS_SUCCESS,
    payload: payload,
  }
}

export function getHistoryRankingRewardsFailed() {
  return {
    type: GET_HISTORY_RANKING_REWARDS_FAILED,
  }
}

export default {
  getDepositPools,
  getDepositPoolsSuccess,
  getDepositPoolsFailed,

  getWithdrawPools,
  getWithdrawPoolsSuccess,
  getWithdrawPoolsFailed,

  updateDepositPools,
  updateDepositPoolsSuccess,
  updateDepositPoolsFailed,

  updateWithdrawPools,
  updateWithdrawPoolsSuccess,
  updateWithdrawPoolsFailed,

  getListPools,
  getListPoolsSuccess,
  getListPoolsFailed,

  createPool,
  createPoolSuccess,
  createPoolFailed,

  editPool,
  editPoolSuccess,
  editPoolFailed,

  closePool,
  closePoolSuccess,
  closePoolFailed,

  deleteNFTgame,
  deleteNFTgameSuccess,
  deleteNFTgameFailed,

  deleteNFTmarket,
  deleteNFTmarketSuccess,
  deleteNFTmarketFailed,

  depositHashchipPool,
  depositHashchipPoolSuccess,
  depositHashchipPoolFailed,

  withdrawHashChipPool,
  withdrawHashChipPoolSuccess,
  withdrawHashChipPoolFailed,

  getStatisticHashChipPool,
  getStatisticHashChipPoolSuccess,
  getStatisticHashChipPoolFailed,

  getHistoriesHashChipPool,
  getHistoriesHashChipPoolSuccess,
  getHistoriesHashChipPoolFailed,

  getProcessHashChipPool,
  getProcessHashChipPoolSuccess,
  getProcessHashChipPoolFailed,

  getRankingRewards,
  getRankingRewardsSuccess,
  getRankingRewardsFailed,

  getHistoryRankingRewards,
  getHistoryRankingRewardsSuccess,
  getHistoryRankingRewardsFailed,
}
